import React  from 'react';
import './App.css';
import data from './content/Team.json';
import {BsGlobe} from 'react-icons/bs';
import {FaLinkedinIn, FaTwitter, } from 'react-icons/fa';
import logo from './assets/phoenix-logo-small.png'
import TeamCard from './components/TeamCard';


function About() {
  // setHidden(document.documentElement.scrollTop > 1100); 
  console.log(5);
    

  return (
    <div className="App">
      <div className="about-landing">
        <img src={data.Landing.logo} className="about-landing-logo"/>
        <p className="about-landing-title">Our mission is to propel the best, most impactful healthcare startups forward.</p>
        <p className="about-landing-text">Innovation in healthcare is messy, exciting, and hard. Our 3-month cohort programs help promising
          healthcare startups—here defined as any startup that isn't working at a lab bench—find their footing,
          recruit talent, and get plugged into a community of mentors, investors, and students.
        </p>
      </div>

      {/* <div className="about-info">
        <div className="about-info-numbers">
          <h3 className="about-info-title">By the numbers:</h3>

        </div>
        <div className="about-info-news">
          <h3 className="about-info-title">Health Engine news</h3>

        </div>
      </div> */}

      <div className="team">
        <h3 className="team-title">Meet the team...</h3>
        <div className="team-wrapper">
          {
            data.team.map((person, idx) => (
              <TeamCard
              linkedinLink={person.linkedin}
              propic={person.picture}
              name={person.name}
              title={person.title}
              major={person.major}
              bio={person.bio}
              />
            ))
          }
        </div>
      </div>

      <div className="phoenix">
        <h3 className="phoenix-title">...and the team behind the team</h3>
        <p className="phoenix-description"><a href="https://phoenix.berkeley.edu">Phoenix Consulting Group</a> is UC Berkeley's
          healthcare consulting group. We've taken on projects ranging from Pfizer to Clover Health.</p>
        <div className="phoenix-wrapper">
          <img src={data.phoenix.picture} className="phoenix-picture"></img>
        </div>
      </div>





{/* About us / Connections / logo promo teaser */}


{/* Add a section below about Phoenix Consulting Group and being a student group. */}
{/* <div className="content"> 
        <div> 
            <img src={logo} alt="h" width="25rem" style={{verticalAlign:'middle', marginBottom:'1rem'}}/>
            </div>
        <div className="content-tagline">
            <h4> {data.phoenix.tagline} </h4>
        </div>
            <div className="content-heading">
             <h3 className="gradient-text"> {data.phoenix.heading} </h3>
        </div>
        <div className="content-text" style={{paddingRight:'15%'}}>
                        <p> Health Engine is founded and led by students of UC Berkeley’s 
                        <a href="https://phoenix.berkeley.edu" className="content-link" rel="noreferrer" target="_blank"> 
                            {' '}Phoenix Consulting Group</a>. We are a community of students who consult for corporations, non-profits, and startups in the healthcare sector. 
                            Each semester Phoenix take on a set of diverse clients (including but not limited to Pfizer, the American Red Cross, Medtronic, and Kaiser Permanente.) and provide data-driven solutions to problems in market research and landscaping, sales & marketing, financials & data analysis, and corporate strategy & expansion.  </p>
                        <p> 
                        Phoenix Consulting Group is the university's oldest organization dedicated to consulting for the healthcare sector, and it brings together some of the most passionate individuals in the student body.
                        As part of furthering our commitment to improving healthcare, we are excited to present Health Engine, drawing on our passion, network, and experience in the healthcare industry.
                        We are inspired in part by the success of the campus's <a href="https://xcelerator.berkeley.edu/" className="content-link" rel="noreferrer" target="_blank"> 
                            {' '}Blockchain Xcelerator</a>, the world's premier blockchain startup accelerator. We are supported in part by the Sutardja Center for Entrepreneurship & Technology. 
                        </p>
                    </div>
        

    
        <hr style={{width:'75%', textAlign:'center', marginLeft:'1rem'}}/>

        </div> */}



    </div>
  );
}

export default About;
